import { observer } from 'mobx-react';
import * as React from 'react';
import { FormControl } from 'react-bootstrap';
import { inject } from '../../../../utils/decorators';
import VorgangFormularElement from '../../VorgangFormularElement';
import { AuftragStore } from '../../../../stores/AuftragStore';
import { VorgangStore } from '../../../../stores/VorgangStore';
import { ApiStore } from '../../../../stores/ApiStore';
import { BpsReferenzkraftKalibrierungRili2021Store } from '../../../../stores/BpsReferenzkraftKalibrierungRili2021Store';
import { IObjekt } from '../../../../models/ApiTypes';
import BpsReferenzkraftRollenDurchmesser from './BpsReferenzkraftRollenDurchmesser';
import BpsReferenzkraftRollensaetze from './BpsReferenzkraftRollensaetze';
import BpsPruefortParameter from './BpsPruefortParameter';
import BpsReferenzkraftWaegezelle from './BpsReferenzkraftWaegezelle';
import BpsReferenzkraftDrehzahlSchlupf from './BpsReferenzkraftDrehzahlSchlupf';
import BpsReferenzkraftKMGInfo from './../BpsReferenzkraftKMGInfo';
import * as ApiTypesBps from '../../../../models/ApiTypesBps2021';
import Callout from '../../../site/Callout';

export interface IBpsReferenzkraftkalibrierungProps {
  elementguid: string;
  kategorieguid: string;
  editable?: boolean;
  value?: string;
  element: VorgangFormularElement;
}

/** Kapselkomponemnte für die BPS Kalibrierung nach Referenzkraftverfahren nach Richtlinie 2021 */
@observer
export default class BpsReferenzkraftKalibrierungRili2021 extends React.Component<IBpsReferenzkraftkalibrierungProps, {}> {

  @inject(AuftragStore) auftragStore: AuftragStore;
  @inject(VorgangStore) vorgangStore: VorgangStore;
  @inject(ApiStore) apiStore: ApiStore;
  @inject(BpsReferenzkraftKalibrierungRili2021Store) kalibrierungStore: BpsReferenzkraftKalibrierungRili2021Store;

  constructor(props: IBpsReferenzkraftkalibrierungProps) {
    super(props);
    this.kalibrierungStore.clear();
  }

  async componentDidMount() {
    // Zu betrachtenden BPS aus Auftrag ermitteln
    let objekt: IObjekt | undefined = undefined;
    let vorgang = this.vorgangStore.vorgang;
    if (vorgang && vorgang.objekte) {
      for (var obj of vorgang.objekte) {
        if (obj.typ.toLocaleLowerCase() === 'bps') {
          objekt = obj;
          break;
        }
      }
    }
    this.kalibrierungStore.setKalibrierGegenstand(objekt);
    if (objekt) {
      const objektVorlage = await this.apiStore.objektVorlage(objekt.objektguid);
      if (objektVorlage.ok) {
        this.kalibrierungStore.setObjektVorlage(objektVorlage.json);
      }
    }
    // Gespeicherte Messung übernehmen
    if (this.props.value) {
      let messung: ApiTypesBps.IBpsReferenzkraftRolleMessung = this.kalibrierungStore.datensatz;
      messung = JSON.parse(this.props.value) as ApiTypesBps.IBpsReferenzkraftRolleMessung;
      this.kalibrierungStore.setMesswerte(messung);
    }
    this.kalibrierungStore.setReadOnly(this.props.editable ? !this.props.editable : true);
  }

  render() {
    return (
      <div>
        <BpsReferenzkraftKMGInfo/>
        {(!this.kalibrierungStore.kalibrierGegenstand || !this.kalibrierungStore.objektVorlage) ?
          <Callout bsStyle="danger">
            <p>Bitte wählen Sie für die Auswertung zuerst einen Bremsprüfstand aus</p>
          </Callout>
        :
          <div>
            <BpsPruefortParameter titel="Prüfortparameter zu Beginn der Kalibrierung" ziel={this.kalibrierungStore.datensatz.pruefortparameter.beginn}/>
            <BpsReferenzkraftRollenDurchmesser/>
            <BpsReferenzkraftWaegezelle/>
            <BpsReferenzkraftRollensaetze/>
            <BpsReferenzkraftDrehzahlSchlupf/>
            <BpsPruefortParameter titel="Prüfortparameter am Ende der Kalibrierung" ziel={this.kalibrierungStore.datensatz.pruefortparameter.ende}/>
          </div>
        }
        {/* Kompletten Messdatensatz als verstecktes Feld im Request übergeben */}
        <FormControl type="hidden" name={`${this.props.kategorieguid}[${this.props.elementguid}][json]`} value={JSON.stringify(this.kalibrierungStore.datensatz)}/>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/bps/rili2021/BpsReferenzkraftKalibrierungRili2021.tsx